import {createRouter, createWebHistory} from 'vue-router';

const routes = [
    {
        path: "/",
        component: () => import('../components/MainIndex.vue'),
        meta:{
            title:"四川中安帮科技有限公司"
        }
    },
    {
        path: "/hellow",
        component: () => import('../components/HelloWorld.vue')
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        window.document.title = to.meta.title;
    }else{
        window.document.title = '安科兴';
    }
    next()
})

export default router;